import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { AiUsagePage, AI_USAGE_RANGES } from '@/pages/admin/ai-usage/AiUsagePage';
import { dataTableSearchSchema } from '@/lib/validation/dataTableSearchSchema';

export const Route = createFileRoute('/admin/ai-usage/')({
  component: AiUsagePage,
  validateSearch: dataTableSearchSchema({
    tenantId: z.string().optional(),
    range: z.enum(AI_USAGE_RANGES).optional()
  })
});
